import { Component, OnInit } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const exampleHtml = `
<se-po-setup-bar
  seFeDataTitle="Create Account"
  [percentage]="percentage">
</se-po-setup-bar>
<div>
  <form [formGroup]="form">
    <se-fe-form-field-quantity
      formControlName="percentage"
      [seFeDataMax]="100"
      [seFeDataMin]="0"
      [seFeEnableManualInput]="true">
    </se-fe-form-field-quantity>
  </form>
</div>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'

export class SetupBarExampleComponent implements OnInit {
  public form: UntypedFormGroup
  public percentage: number

  public ngOnInit(): void {
    this.percentage = 65
    this.form = new UntypedFormGroup({
      percentage: new UntypedFormControl(this.percentage)
    })

    this.form.valueChanges.subscribe(val => {
      this.percentage = val.percentage
    })
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-setup-bar-example',
  template,
  styleUrls: ['./setup-bar-docs.component.scss'],
  standalone: false,
})
export class SetupBarExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public form: UntypedFormGroup
  public percentage: number

  public ngOnInit(): void {
    this.percentage = 65
    this.form = new UntypedFormGroup({
      percentage: new UntypedFormControl(this.percentage)
    })

    this.form.valueChanges.subscribe(val => {
      this.percentage = val.percentage
    })
  }
}
